import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQuery";

export const formsAPI = createApi({
  reducerPath: "formsAPI",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getLineofCredit: builder.query({
      query: (params) => {
        return {
          url: `api/request_line_of_credit/`,
          params,
        };
      },
    }),
    getBecomeSeller: builder.query({
      query: (params) => {
        return {
          url: `api/become_supplier/`,
          params,
        };
      },
    }),
    getLineofCreditExcel: builder.query({
      query: (params) => {
        return {
          url: `api/download_request_line_of_credit/`,
          params,
        };
      },
    }),
    getLoCCategory: builder.query({
      query: (params) => {
        return {
          url: `api/accounts/rupifi-categories/`,
          params,
        };
      },
    }),
    createNewCategory: builder.mutation({
      query: (data) => ({
        url: "api/accounts/rupifi-categories/",
        method: "POST",
        body: data,
      }),
    }),
    updateNewCategory: builder.mutation({
      query: (data) => ({
        url: "api/accounts/rupifi-categories/",
        method: "PUT",
        body: data,
      }),
    }),
    refetchRupifiStatus: builder.query({
      query: (data) => ({
        url: "api/accounts/refetch-rupifi-status/",
        method: "GET",       
      }),
    }),
  }),
});

export const {
  useLazyGetLineofCreditQuery,
  useLazyGetBecomeSellerQuery,
  useLazyGetLineofCreditExcelQuery,
  useLazyGetLoCCategoryQuery,
  useCreateNewCategoryMutation,
  useUpdateNewCategoryMutation,
  useLazyRefetchRupifiStatusQuery,
} = formsAPI;

export default formsAPI;
